module.exports = __webpack_public_path__ + "static/media/question_mark.511c5233.svg";